import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  FullName,
  GrantTerm,
  GrantedArea,
  MEDIUM_ITEM_SIZE,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityCardsToExternalEntitiesLongTermProvideTemplate = {
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  unit: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityCardsToExternalEntitiesLongTermProvideTemplate: TemplatesValue<SecurityCardsToExternalEntitiesLongTermProvideTemplate> =
  {
    fileName: "DanhSachNhanVienDaiHanCapMoi",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...FullName,
        itemSize: MEDIUM_ITEM_SIZE,
      },
      Sex,
      PersonalId,
      Regency,
      {
        ...Team,
        header: "Đơn vị",
      },
      GrantTerm,
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: ["name", "sex", "personalId", "regency", "unit", "grantTerm", "grantedArea", "note"],
  };
